import { Component } from '@angular/core';

@Component({
  templateUrl: './confirm-data.page.html',
})
/**
 * ConfirmDataPage
 */
export class ConfirmDataPage {}
